
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import Themeable from 'vuetify/lib/mixins/themeable';
import { CreateDatabaseForm } from '@/services/Database/forms/CreateDatabaseForm';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';
import { DatabaseRepositoryInterface } from '@/services/Database/interfaces';
import WebsiteRepositoryInterface, { Website } from '@/services/Website/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'databaseRepository',
    'serverRepository',
    'websiteRepository',
  ],
})
export default class CreateDatabase extends Vue {
  private form: WPXFormValue<CreateDatabaseForm> = new WPXFormValue(CreateDatabaseForm);

  private databaseRepository!: DatabaseRepositoryInterface;
  private serverRepository!: ServerRepositoryInterface;
  private websiteRepository!: WebsiteRepositoryInterface;

  private loading: boolean = true;

  private servers: ServerInterface[] = [];

  private websites: Website[] = [];
  private _websiteSearch: string = '';
  public websiteSearchLoading: boolean = false;

  public get websiteSearch(): string {
    return this._websiteSearch;
  }

  public async created(): Promise<void> {
    try {
      await this.getServers();
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

  private async getServers(): Promise<void> {
    this.servers = await this.serverRepository.getAllServers();
  }

  public set websiteSearch(val: string) {
    if (val && val.length < 3) {
      return;
    }

    this._websiteSearch = `server=${this.form.data.server}&domain=${val}`;
    this.websiteSearchLoading = true;
    this.websiteRepository.getByServerAndDomain(this.form.data.server, val).then((websites) => {
      this.websites = websites;
      this.websiteSearchLoading = false;
    }).catch((err) => {
      this.$errorDialog.show(err.message);
    });
  }

  private async createDatabase(): Promise<void> {
    try {
      await this.databaseRepository.createDatabase({
        name: this.form.data.name,
        password: this.form.data.password,
        passwordConf: this.form.data.passwordConf,
        server: this.form.data.server,
        websiteId: this.form.data.websiteId,
      });

      this.$successDialog.show('Database Created Successfully!');
      await this.$router.push({ name: 'database_list' });
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

}
